<script>
import TimelineItemInner from './TimelineItemInner'
import { convert } from '../../utils/labReport'

export default {
  name: 'TimelineItem',
  components: {
    TimelineItemInner
  },
  props: {
    report: {
      type: Object,
      required: true
    },
    actions: { type: Boolean, default: () => true }
  },
  methods: {
    deleteReport() {
      this.$emit('delete', this.report._id)
    }
  },
  computed: {
    results() {
      const normalize = ({ quantity, biomarker, ...result }) => ({
        ...result,
        ...biomarker,
        quantity: _.round(quantity, 2)
      })

      return this.report && this.report.results.length
        ? this.report.results.map(normalize)
        : null
    }
  }
}
</script>

<template>
  <div v-if="report" class="report">
    <div class="container">
      <h4 class="is-pulled-right title is-5 has-text-secondary lab-name">
        {{ report.lab }}
      </h4>
      <h4 class="title is-5 has-text-secondary is-uppercase">
        <i class="fas fa-vial" />
        {{ report.date | moment('MMM DD') }}
      </h4>
      <div class="results">
        <div v-for="item in results" :key="item.id" class="result">
          <TimelineItemInner :item="item" />
        </div>
      </div>
      <nav v-if="actions" class="report--ui container columns is-hidden-print">
        <div class="column is-clearfix">
          <div class="buttons is-pulled-right">
            <b-button
              class="is-tertiary"
              size="is-small"
              outlined
              rounded
              tag="router-link"
              :to="{ name: 'EditLabReportView', params: { id: report._id } }"
            >
              Edit report
            </b-button>
            <b-button
              class="is-tertiary"
              size="is-small"
              outlined
              rounded
              icon-pack="fa"
              icon-right="trash-alt"
              @click="deleteReport"
            />
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.report
  background: #f5f7f9
  border: none
  box-shadow: none
  border-radius: 5px
  padding: 20px
  margin-top: 10px
  .lab-name
    font-weight: 100
  .title .svg-inline--fa
    margin-right: 5px
  .results
    margin-top: 20px
  &--ui
    margin-top: 5px
</style>
